import { exhaustMap } from 'rxjs/operators';
import { DialogEventEnum } from 'app/ui/dialog/dialog-event.enum';
import { Subscription, timer } from 'rxjs';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';

import { Application } from './application.model';
import { ApplicationsService } from './applications.service';
import { CreateApplicationComponent } from './create-application/create-application.component';
import { CreateApplicationDcComponent } from './create-application-dc/create-application-dc.component';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { Filter } from './filter/filter.component';
import { UserSettingsService } from 'app/user/user-settings.service';

@Component({
  selector: 'applications',
  templateUrl: 'applications.component.html',
  styleUrls: ['applications.component.scss']
})
export class ApplicationsComponent implements OnInit, OnDestroy {
  applications: Application[];

  applicationsCount: number;

  displayedColumns = ['name', 'id', 'token'];

  sortBackward = true;

  sortName = 'id';

  // Модель для компонента filter
  filter: Filter = { name: '' };

  // Текущее значение запроса поиска
  filterName: string = '';

  count: number = -1;

  page: number = 1;

  batchSize: number = 20;

  _subscription: Subscription;

  _applicationsSubscription: Subscription;

  _serviceTypeSubscription: Subscription;

  isCustomizedApp: boolean;

  @ViewChild('headerElement')
  headerElement: ElementRef;

  getApplications(): Application[] {
    const applications = this.applicationsService.search(this.filterName);
    applications.sort((app1, app2) =>
      this.sortBackward
        ? app2[this.sortName].localeCompare(app1[this.sortName])
        : app1[this.sortName].localeCompare(app2[this.sortName])
    );
    this.count = applications.length;
    this.applicationsCount = applications.length;
    return applications.slice(
      (this.page - 1) * this.batchSize,
      this.page * this.batchSize
    );
  }

  constructor(
    private applicationsService: ApplicationsService,
    private dialogService: UIDialogService,
    public userSettingsService: UserSettingsService
  ) { }

  ngOnInit() {
    this._subscription = this.dialogService.dialogEvents.subscribe(
      (event: DialogEventEnum) => {
        if (event === DialogEventEnum.save) {
          this.sortName = 'id';
          this.sortBackward = true;
          this.updateApplications();
        }

        if (event === DialogEventEnum.delete) {
          this.updateApplications();
        }
      }
    );
    this.applications = this.getApplications();
    this.applicationsCount = this.applications.length;
    this._applicationsSubscription = timer(10000, 10000).subscribe(() => {
      this.applicationsService
        .getApplications(this.userSettingsService.serviceType, this.filterName)
        .subscribe(applications => {
          this.applicationsService.updateApplications(applications);
          this.applications = this.getApplications();
        });
    });

    this._serviceTypeSubscription = this.userSettingsService.serviceType$.subscribe(
      () => {
        this.applications = this.getApplications();
        this.isCustomizedApp = this.applications.find(app => app.isCustomized) ? true : false;
      }
    );
  }

  updateApplications() {
    this.applications = this.getApplications();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._applicationsSubscription.unsubscribe();
  }

  canCreateApplication() {
    return !this.isCustomizedApp && this.userSettingsService.serviceType === 'ic' ? false : true;
  }

  createApplication() {
    if (!this.isCustomizedApp && this.userSettingsService.serviceType === 'ic') {
      return;
    }

    if (this.userSettingsService.serviceType === 'dc') {
      this.dialogService.open(CreateApplicationDcComponent);
    } else {
      this.dialogService.open(CreateApplicationComponent);
    }
  }

  onPageChange(page: number): void {
    this.headerElement.nativeElement.scrollIntoView({
      block: 'center',
      behavior: 'smooth'
    });
    this.page = page;
    this.applications = this.getApplications();
  }

  sort(column: string): void {
    if (this.isSortDisabled()) {
      return;
    }

    if (this.sortName !== column) {
      this.sortBackward = false;
    } else {
      this.sortBackward = !this.sortBackward;
    }
    this.sortName = column;
    this.applications = this.getApplications();
  }

  applyFilter(filter: Filter) {
    this.page = 1;
    this.filterName = filter.name;
    this.applications = this.getApplications();
  }

  trackByFn(index: number, item: Application) {
    return item.id;
  }

  showControlsForCustomApps() {
    return this.isCustomizedApp || this.applicationsCount > 1;
  }

  isSortDisabled() {
    return this.applicationsCount === 1;
  }

  showFooter() {
    return this.count > this.batchSize;
  }
}
